import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import Typography from 'ui/components/typography'

import useStyles from './styles'

const PrivacyPolicyConditions = ({ handleClose, data: name }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <DialogTitle disableTypography className={classes.dialogTitle} id="customized-dialog-title">
        <Typography variant="h4">{t('legal.privacyPolicyConditionsTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div
          className={classes.legalTerms}
          dangerouslySetInnerHTML={{ __html: t('legal.privacyPolicyConditionsText', { rate_name: name }) }}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button color="secondary" variant="contained" onClick={handleClose}>
          {t('common.accept')}
        </Button>
      </DialogActions>
    </>
  )
}

export default PrivacyPolicyConditions
